module.exports = __webpack_public_path__ + "static/media/anc4ru.3e0d442b.pdf";